module.exports = __webpack_public_path__ + "static/img/sence-7-map.cc53b61.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sence-7-map.png
// module id = yqHa
// module chunks = 1